export default class ChangeNotifier {
  addListener(listener: () => void) {}
  removeListener(listener: () => void) {}
  notifyListeners() {}
  dispose() {}
}
